import cakeFeature from "../../assets/menu/featured/wedding-cake.jpeg";
import cupcakeFeature from "../../assets/menu/featured/succulent-cupcakes.jpg";
import cookieFeature from "../../assets/menu/featured/bluey-cookies.jpeg";
import cakesicleFeature from "../../assets/menu/featured/assorted-cakesicles.jpg";
import tartsBarsBrowniesFeature from "../../assets/menu/featured/fruit-tart.jpg";
import MenuFeature from "./MenuFeature";

function Menu() {
  return (
    <>
      <div className="wrapper">
        <h1>Explore the dessert menu</h1>
        <p>
          Custom cakes, cupcakes, decorated sugar cookies, cakesicles, and more
          — made to order for your next special event.
        </p>
      </div>
      <MenuFeature
        link="/menu/cakes"
        img={cakeFeature}
        imgAlt="Cake Feature"
        heading="cakes"
        text="Endless designs are possible, from simple buttercream designs to intricate fondant artwork."
      />
      <MenuFeature
        link="/menu/cupcakes"
        img={cupcakeFeature}
        imgAlt="Cupcake Feature"
        heading="cupcakes"
        text="Choose between mini and standard sized cupcakes for these shareable delights."
      />
      <MenuFeature
        link="/menu/cookies"
        img={cookieFeature}
        imgAlt="Cookie Feature"
        heading="cookies"
        text="Freshly baked butter cookies decorated with royal icing and individually wrapped."
      />
      <MenuFeature
        link="/menu/cakesicles"
        img={cakesicleFeature}
        imgAlt="Cakesicle Feature"
        heading="cakesicles"
        text="The perfect blend of cake and frosting encased in a white, milk, or dark chocolate shell."
      />
      <MenuFeature
        link="/menu/tarts-bars-brownies"
        img={tartsBarsBrowniesFeature}
        imgAlt="Tarts, Bars, and Brownies Feature"
        heading="tarts, bars, brownies"
        text="Elevate your dessert table with an assortment of lemon bars, fruit tarts, and rich, fudgy brownies."
      />
    </>
  );
}

export default Menu;
